<div>
  <h2 class="block-title">
    {{ "Events" | translate }}
  </h2>
</div>
<div class="row">
  <div class="col-12">
    <div class="table-responsive mb-5" *ngIf="events.data.length; else noData">
      <table appResponsiveTable class="table table-default">
        <thead class="table-header text-center">
          <tr>
            <th scope="col">{{ "Event name" | translate }}</th>
            <th scope="col">{{ "Status" | translate }}</th>
            <!-- <th scope="col">{{ "Actions" | translate }}</th> -->
          </tr>
        </thead>
        <tbody class="table-body">
          <ng-container *ngFor="let event of events.data">
            <tr class="text-center" *ngIf="event">
              <td
                class="link"
                scope="col"
                data-label="تاريخ المشرق"
                (click)="viewEvent(event.id)"
              >
                {{ helpers.getElementTranslatedName(event.event) }}
              </td>

              <ng-container>
                <td
                  class="text-warning"
                  scope="col"
                  *ngIf="event.event.status === 'UNDER_REVIEW'"
                >
                  {{ "Under review" | translate }}
                </td>
                <td
                  class="text-primary"
                  scope="col"
                  *ngIf="event.event.status === 'APPROVED'"
                >
                  {{ "Approved" | translate }}
                </td>
                <td
                  class="text-danger"
                  scope="col"
                  *ngIf="event.event.status === 'REJECTED'"
                >
                  {{ "Rejected" | translate }}
                </td>
                <td
                  class="text-danger"
                  scope="col"
                  *ngIf="event.event.status === 'DELETED'"
                >
                  {{ "Deleted" | translate }}
                </td>
                <td
                  class="text-danger"
                  scope="col"
                  *ngIf="event.event.status === 'CLOSED'"
                >
                  {{ "Closed" | translate }}
                </td>
              </ng-container>
            </tr>
            <tr class="text-center" *ngIf="!event">
              <td class="link" scope="col" data-label="تاريخ المشرق">
                <span class="skeleton-box"></span>
              </td>
              <td scope="col" data-label="{{ 'Status' | translate }}">
                <span class="skeleton-box"></span>
              </td>

              <!-- <td scope="col" data-label="{{ 'Action' | translate}}">
                  <span class="skeleton-box"></span>
                </td> -->
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-pagination
  *ngIf="events.meta"
  [meta]="events.meta"
  (goPage)="goToPage($event)"
  (goNext)="onNext()"
  (goPrev)="onPrev()"
>
</app-pagination>

<ng-template #noData>
  <app-nodata
    title="{{ 'No Results Found' | translate }}"
    desc=""
    link=""
    img="assets/images/reports/no-reports.png"
  ></app-nodata>
</ng-template>
